import { verticalTypesEnum } from '../../../shared/src/enums/vertical-types.enum';
import { AppService } from '../../../shared/src/services/app.service';
import { AppActionEnum } from '../../../shared/src/enums/app-action.enum';

export const VerticalService = {
    /**
     * To be filled with this.setVerticalMenuItemMethods()
     * Used to change verticals in this.openVertical()
     **/
    setCurrentVerticalId: () => {},
    setCurrentCategorySet: () => {},
    gaEventTracking: () => {},
    afterVerticalChange: () => {},

    setVerticalMenuItemMethods(data) {
        this.setCurrentVerticalId = data.setCurrentVerticalId;
        this.setCurrentCategorySet = data.setCurrentCategorySet;
        this.gaEventTracking = data.gaEventTracking;
        this.afterVerticalChange = data.afterVerticalChange;
    },

    openVertical(vertical, options) {
        const {
            id,
            location,
            categoryId,
            subCategoryId,
            isSameLocation,
            name,
            type,
            action,
        } = vertical;
        const { isLoggedIn, isMobile } = options;

        const sso = isLoggedIn ? 'Post' : 'Pre';
        const platform = isMobile ? 'mobile' : 'desktop';
        const targetPath = location?.split('#')[0];

        // Add GA events.
        this.gaEventTracking(
            `Verticals ${platform}`,
            `Click '${name}' ${sso}`,
            name,
        );

        // NEW: handle widget-type verticals
        if (type === 'widget') {
            const actionId = this.widgetActionMap(action);
            if (actionId) {
                AppService.ctaHandler(actionId);
            }
            return;
        }

        if (vertical.action === 'externalLink') {
            window.open(location, vertical.target);
            return;
        }

        // Save new Verticals / categories state
        this.setCurrentVerticalId(id, targetPath);
        this.setCurrentCategorySet({
            categoryId,
            subCategoryId,
        }, targetPath);

        /*
         * Render new vertical's content, if it's located right on the same page.
         * Otherwise location will be changed.
         */
        if (isSameLocation) {
            // clear hash before vertical change
            window.location.hash = '';
            this.afterVerticalChange();
        } else {
            window.location = location;
        }
    },

    openSportVertical(verticals) {
        let sportVertical;

        for (const vertical of verticals) {
            if (vertical.type === verticalTypesEnum.SPORT) {
                sportVertical = vertical;
                break;
            }
        }

        if (sportVertical) {
            this.openVertical(
                sportVertical,
                {
                    isLoggedIn: Player.isLoggedIn(),
                    isMobile: AsgFW.isMobilePamPlatform(),
                },
            );
        } else {
            Tools.error('Sport vertical did not found');
        }
    },

    widgetActionMap: function(actionKey) {
        let map = {
            bonusOffers: AppActionEnum.SHOW_BONUS_OFFERS,
            changePassword: AppActionEnum.SHOW_CHANGE_PASSWORD,
            myAccount: AppActionEnum.MY_ACCOUNT,
            details: AppActionEnum.SHOW_MY_DETAILS,
            gameHistory: AppActionEnum.SHOW_GAMES_HISTORY,
            myBonuses: AppActionEnum.SHOW_MY_BONUSES,
            preferences: AppActionEnum.SHOW_MY_PREFERENCES,
            sportHistory: AppActionEnum.SHOW_SPORT_HISTORY,
            transactions: AppActionEnum.SHOW_TRANSACTIONS_HISTORY
        };
        // default to 'navigateTo'
        return map[actionKey] || null;
    }
};
